import { Avatar as AvatarPrimitive } from 'radix-ui';
import type { ComponentProps } from 'react';

export const Avatar = AvatarPrimitive.Root;
export const AvatarImage = AvatarPrimitive.Image;
export const AvatarFallback = AvatarPrimitive.Fallback;

export type AvatarProps = ComponentProps<typeof AvatarPrimitive.Root>;
export type AvatarImageProps = ComponentProps<typeof AvatarPrimitive.Image>;
export type AvatarFallbackProps = ComponentProps<typeof AvatarPrimitive.Fallback>;
